import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMathLessThanCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM15.174 7.65085L16.0992 9.42402L11.1619 12L16.0992 14.576L15.174 16.3492L6.83815 12L15.174 7.65085Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathLessThanCircle;
